module.exports = __webpack_public_path__ + "static/media/default.5063d1fa.png";